(() => {
  if (window.__scrollRestorationInitialized) return;
  window.__scrollRestorationInitialized = true;

  const STORAGE_PREFIX = 'scroll-position:';
  const NEXT_KEY = 'scroll-restore:next';
  const LINK_SELECTOR = '[data-scroll-restore-link]';

  const toStorageKey = (url) => {
    try {
      const target = new URL(url, window.location.origin);
      return `${STORAGE_PREFIX}${target.pathname}${target.search}`;
    } catch (error) {
      return '';
    }
  };

  let restoreDone = false;

  const restorePosition = async (viewTransition) => {
    if (restoreDone) return;
    if (window.location.hash) return;
    if (window.scrollY > 0) return;

    const expectedKey = sessionStorage.getItem(NEXT_KEY);
    const currentKey = `${STORAGE_PREFIX}${window.location.pathname}${window.location.search}`;
    if (!expectedKey || expectedKey !== currentKey) return;

    sessionStorage.removeItem(NEXT_KEY);

    let saved = null;
    try {
      saved = sessionStorage.getItem(currentKey);
    } catch (error) {
      return;
    }

    if (!saved) return;

    let parsed = null;
    try {
      parsed = JSON.parse(saved);
    } catch (error) {
      return;
    }

    const x = Number(parsed?.x ?? 0);
    const y = Number(parsed?.y ?? 0);
    if (y <= 0 && x <= 0) return;

    if (viewTransition?.finished) {
      try {
        await viewTransition.finished;
      } catch (error) {
        // Ignore transition errors.
      }
    }

    requestAnimationFrame(() => {
      window.scrollTo({ left: x, top: y, behavior: 'instant' });
      restoreDone = true;
    });
  };

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest(LINK_SELECTOR) : null;
    if (!(link instanceof HTMLAnchorElement)) return;
    if (event.defaultPrevented) return;
    if (link.target && link.target !== '_self') return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const href = link.getAttribute('href');
    if (!href || href.startsWith('#')) return;

    const key = toStorageKey(href);
    if (!key) return;

    try {
      const payload = JSON.stringify({ x: window.scrollX, y: window.scrollY });
      sessionStorage.setItem(key, payload);
      sessionStorage.setItem(NEXT_KEY, key);
    } catch (error) {
      // Ignore storage errors.
    }
  });

  window.addEventListener('pageshow', (event) => {
    restorePosition(event?.viewTransition || null);
  });

  window.addEventListener('pagereveal', (event) => {
    restorePosition(event?.viewTransition || null);
  });

  if (document.readyState === 'complete') {
    restorePosition(null);
  } else {
    window.addEventListener('load', () => restorePosition(null), { once: true });
  }
})();
